import { LP_DESIGN_CATEGORIES } from 'app/pages/admin/landing-pages-v2/constants';

export const landingPageDesignsKeys = {
  all: () => ['LANDING_PAGE_DESIGNS'],
  single: (templateId: number | null) => ['LANDING_PAGE_DESIGN', templateId],
  design_access: (templateId: number | null) => [
    'LANDING_PAGE_DESIGN_ACCESS',
    templateId,
  ],
  preview: (landingPageDesignId: number) => [
    'LANDING_PAGE_DESIGN_PREVIEW',
    landingPageDesignId,
  ],
  list: ({
    start,
    limit,
    search,
    category,
    resellerIds,
    active,
    groupIds,
  }: {
    start?: number;
    limit: number;
    search: string;
    category?: LP_DESIGN_CATEGORIES | null;
    resellerIds?: number[];
    active?: boolean | null;
    groupIds?: number[];
  }) => [
    'LANDING_PAGE_DESIGNS',
    start,
    limit,
    search,
    category,
    resellerIds,
    active,
    groupIds,
  ],
  infinite_landing_page_designs: ({
    start,
    limit,
    search,
  }: {
    start?: number;
    limit: number;
    search: string;
  }) => ['INFINITE_LANDING_PAGE_DESIGNS', start, limit, search],
  autocomplete: ({
    start,
    limit,
    search,
  }: {
    start?: number;
    limit?: number;
    search: string;
  }) => ['LANDING_PAGE_DESIGNS_AUTOCOMPLETE', start, limit, search],
  duplicate: () => ['DUPLICATE_LANDING_PAGE_DESIGN'],
};
